import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';

// Renders an FAQ H2 block with H3 questions; pair with faqSchema(items) via SEO's schema prop.
const FAQSection = ({ heading = 'Frequently Asked Questions', items }) => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="py-16 px-8 max-w-4xl mx-auto border-t border-white/10">
      <h2 className="text-2xl md:text-3xl font-light text-white text-center mb-12">{heading}</h2>
      <div className="flex flex-col gap-3">
        {items.map((item, i) => (
          <div key={item.question} className="glass rounded-2xl border border-white/10 overflow-hidden">
            <button
              type="button"
              onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
              className="w-full flex items-center justify-between gap-4 text-left px-6 py-5"
              aria-expanded={openIndex === i}
            >
              <h3 className="text-white text-sm md:text-base font-medium">{item.question}</h3>
              <SafeIcon
                name={openIndex === i ? 'Minus' : 'Plus'}
                className={`text-cyan-400 text-lg shrink-0 transition-transform ${openIndex === i ? 'rotate-180' : ''}`}
              />
            </button>
            {openIndex === i && (
              <p className="px-6 pb-5 text-white/45 text-sm leading-relaxed">{item.answer}</p>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
